/** Shared copy for edit-list tabs (modal + Rules demo). */
export const EDIT_LIST_TAB_SELECT = 'Select teams';
export const EDIT_LIST_TAB_RANK = 'Rank teams';

/** Selection grid on phone: flag height fraction (desktop edit list uses 0.75). */
export const EDIT_LIST_MOBILE_SELECTION_FLAG_FILL = 0.52;

/** Fixed rank row height in mobile Ranking tab (stable drag targets). */
export const EDIT_LIST_MOBILE_RANK_ROW_PX = 42;
